import styled from 'styled-components';
import Dropzone from 'react-dropzone';

import { styledScroll } from 'styles/styledScroll';
import colors from 'themes/Main';

const {
  gray02,
  gray03,
  gray04,
  gray06,
  gray05,
  darkBlue,
  warning,
  danger,
  white,
  dangerBackground,
} = colors;

export const DynamicBlock = styled.div`
  width: 100%;
  padding: 20px 16px;
  background-color: rgba(0, 0, 0, 0.01);
  border-radius: 3px;

  &:first-child {
    margin-top: 16px;
  }

  &:last-child {
    margin-bottom: 32px;
  }
`;

export const Result = styled.div`
  width: auto;
  margin-top: 16px;

  &.line {
    margin-top: 12px;
    width: 100%;
    border-bottom: 1px solid ${gray04};
    margin-bottom: 12px;
    padding-bottom: 12px;
  }
`;

export const FormButtonsWrap = styled.div`
  width: 304px;
  padding: 48px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const DragAndDrop = styled(Dropzone)`
  width: 100%;
`;

export const DragDropSection = styled.section``;

export const Small = styled.small`
  font-size: 12px;
  margin-top: 4px;
  color: ${gray02};
`;

export const TotalPriceWrap = styled.div`
  height: fit-content;
`;

export const TotalPrice = styled.div`
  width: auto;
  color: ${warning};
  font-size: 16px;
  font-weight: 700;
`;

export const DragDropDiv = styled.div`
  min-height: 144px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ isDraging }) => (isDraging ? gray05 : gray06)};
  border: 2px dashed ${({ isDraging }) => (isDraging ? darkBlue : gray03)};
  transition: all 0.5s ease-in-out;
  border-radius: 5px;
  z-index: 1;
`;

export const DragAndDropStatusNull = styled.div`
  cursor: default;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 50%;
  flex-wrap: wrap;

  > h3 {
    font-size: 18px;
    font-weight: 700;
    color: ${({ isDraging }) => (isDraging ? darkBlue : gray02)};
    transition: all 0.5s ease-in-out;
    text-align: center;
  }

  > p {
    margin-bottom: 0;
    font-size: 14px;
    color: ${({ isDraging }) => (isDraging ? darkBlue : gray02)};
    transition: all 0.5s ease-in-out;
    text-align: center;
  }
`;

export const DragedElementsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: fill-available;
  padding: 24px 16px;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 136;
  z-index: 2;

  > div {
    width: 100%;
    padding: 12px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    font-weight: 700;
    color: ${({ isDraging }) => (isDraging ? darkBlue : gray02)};
    z-index: 5;

    &:not(:last-child) {
      border-bottom: 1px solid ${gray05};
    }

    > p {
      margin-bottom: 0;
    }
  }

  ${styledScroll};
`;

export const SavedImagesContainer = styled.div`
  width: 100%;
  max-width: 100%;
  height: auto;
  background: tranparent;
  margin-top: 24px;
  margin-bottom: 8px;
`;

export const ThumbnailsContainer = styled.div`
  margin: 0;
  padding: 0 0 40px;
  max-width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  overflow-y: hidden;
  overflow-x: auto;
  ${styledScroll}
`;

export const savedFilesTitle = styled.div`
  color: ${darkBlue};
  font-size: 16px;
  font-weight: 700;
  width: 100%;
`;

export const ThumbContainer = styled.div`
  width: 300px;
  height: 280px;
  padding: 8px 12px;

  &:first-of-type {
    padding-left: 8px;
  }

  &:last-of-type {
    padding-right: 8px;
  }
`;

export const ThumbImage = styled.div`
  width: 284px;
  height: 200px;
  background: ${({ bg }) => (bg ? `url(${bg})` : gray04)};
  background-size: cover;
  background-repeat: no-repeat;
  background-clip: border-box;
  position: relative;

  ${({ bg }) =>
    !bg &&
    `
    &::before{
      content: 'No Image';
      color: ${darkBlue};
      font-weight: 700;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      text-transform: uppercase;
    }
  `}
`;

export const ThumbInfoContainer = styled.div`
  width: 284px;
  padding: 8px;
  min-height: 80px;
  height: auto;
  background: ${white};
`;

export const ThumbName = styled.div`
  width: 100%;
  font-size: 12px;
  color: ${darkBlue};
  font-weight: 700;
  text-align: center;
  padding: 4px 0;
  text-transform: uppercase;
  margin-bottom: 16px;
`;

export const ThumbAction = styled.div`
  display: flex;
  padding: 0 8px;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
`;

export const RemoveButton = styled.button`
  display: flex;
  align-items: center;
  appearance: none;
  min-width: 16px;
  width: auto;
  height: auto;
  border: none;
  background: transparent;
  transition: all 0.25s ease;
  color: ${({ disabled }) => (disabled ? gray04 : danger)};
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;

  span {
    padding: 4px 8px;
  }

  path {
    transition: all 0.25s ease;
    fill: ${({ disabled }) => (disabled ? gray04 : danger)};
    stroke: ${({ disabled }) => (disabled ? gray04 : danger)};
  }

  &:hover,
  &:focus,
  &:active {
    outline: none;
    border: none;
    color: ${({ disabled }) => (disabled ? gray04 : dangerBackground)};

    path {
      fill: ${({ disabled }) => (disabled ? gray04 : dangerBackground)};
      stroke: ${({ disabled }) => (disabled ? gray04 : dangerBackground)};
    }
  }
`;
